/* =====================================================================
   NO SUGAR – Mejoras de los módulos 2027 (Fase 3)
   Requiere: ns-rotation2027.js, ns-rules2027.js, ns-shop2027.js, ns-quickview-nutri.js
   y ns-entregas2027.js. Configuración en window.NS_MEJORAS (snippets/ns-mejoras2027.liquid).
   No cambia reglas, precios ni descuentos: escucha los avisos de ns-shop2027.js
   ('ns:cart', 'ns:order-render', 'ns:checkout') y agrega piezas encima.
   1. Kcal y proteína en las tarjetas (los alérgenos van en la vista rápida, no filtran).
   2. "¿Cuándo te llega?": fechas de entrega por CP dentro de "Tu pedido".
   3. Totales de kcal y proteína de la selección, por semana.
   4. Resumen fijo en celular: semanas arriba al bajar y resumen del plan desde la barra.
   5. Guardar la selección (si el carrito se pierde, se recupera) y "Repetir mi último pedido".
   ===================================================================== */
(function (global) {
  'use strict';
  var doc = global.document;
  if (!doc) return;
  var S = global.NSShop, Rl = global.NSRules, R = global.NSRotation, N = global.NSNutri, E = global.NSEntregas;
  var CFG = global.NS_MEJORAS || {};
  var K_SEL = 'ns2_seleccion', K_ULT = 'ns2_ultimo_pedido', K_ALG = 'ns2_alergenos', K_NO = 'ns2_aviso_cerrado';
  var DIAS_SELECCION = 14;
  if (!S || !Rl || !R) return;
  var esc = S.esc;

  function leer(k, d) { try { var v = JSON.parse(global.localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function escribir(k, v) { try { if (v == null) global.localStorage.removeItem(k); else global.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* opcional */ } }
  function sesion(k, v) { try { if (v === undefined) return global.sessionStorage.getItem(k); global.sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function fmt(n) { return Math.round(n || 0).toLocaleString('es-MX'); }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : 0; }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function host() { return doc.querySelector('#ns2Planes, #ns2Alc, #ns2Express, #ns2Custom'); }

  // Datos nutricionales de los 4 menús (una vez por sesión).
  var mapa = null;
  function datos() {
    if (!N) return Promise.resolve({});
    if (!mapa) mapa = N.todos();
    return mapa;
  }
  function datoDe(handle) {
    return datos().then(function (m) { return m[handle] || (N ? N.get(handle) : null); });
  }

  /* =========== 1. Tarjetas: kcal y proteína =========== */
  // Los alérgenos no ocultan platillos (se ve toda la oferta): se muestran al abrir la vista rápida.
  try { global.localStorage.removeItem(K_ALG); } catch (e) { /* opcional */ }

  function decorar(grid) {
    var cards = grid.querySelectorAll('.ns2-card[data-handle]');
    if (!cards.length) return;
    datos().then(function (m) {
      if (!grid.isConnected) return;
      cards.forEach(function (c) {
        var d = m[c.getAttribute('data-handle')];
        if (!d || !N.tieneDatos(d) || c.querySelector('.ns2-card__nutri')) return;
        var name = c.querySelector('.ns2-card__name');
        if (name) {
          name.insertAdjacentHTML('afterend', '<p class="ns2-card__nutri"><span><b>' + fmt(d.kcal) + '</b> kcal</span>' +
            '<span><b>' + fmt(d.proteina) + ' g</b> <span class="ns2x-l">proteína</span><span class="ns2x-s">prot.</span></span></p>');
        }
      });
    });
  }

  function vigilarGrids() {
    doc.querySelectorAll('.ns2 [data-box="grid"]').forEach(function (grid) {
      new MutationObserver(function () { decorar(grid); }).observe(grid, { childList: true });
      decorar(grid);
    });
  }

  /* =========== 2 y 3. Hoja "Tu pedido": entregas por CP y totales =========== */
  var cobertura = null;
  function cargarCobertura() {
    if (!E || !CFG.cobertura) return Promise.resolve(null);
    if (!cobertura) cobertura = E.load(CFG.cobertura).then(function (d) { return E.merge(d, CFG.extra || []); }).catch(function () { return null; });
    return cobertura;
  }

  // Semanas con platillos en el pedido (sin Express, que tiene su propio día).
  function semanasDelPedido(s, ctx) {
    var ids = {};
    s.planOrder.forEach(function (k) { s.plans[k].lines.forEach(function (l) { ids[l.weekId] = true; }); });
    Object.keys(s.alc.weeks).forEach(function (id) { if (s.alc.weeks[id] > 0) ids[id] = true; });
    Object.keys(s.custom.weeks).forEach(function (id) { if (s.custom.weeks[id] > 0) ids[id] = true; });
    return Object.keys(ids).sort().map(function (id) { return Rl.findWeek(ctx.weeks, id); }).filter(Boolean);
  }

  function htmlEntregas(info, weeks, cp) {
    var wa = CFG.whatsapp;
    if (!cp || cp.length !== 5) return '<p class="ns2-small">Escribe tu código postal y te decimos qué día te llega cada semana.</p>';
    if (!info) return '<p class="ns2-small">No pudimos cargar las zonas de entrega. Intenta de nuevo.</p>';
    if (!info.known || !info.covered) {
      var txt = !info.known ? 'No encontramos el código postal ' + esc(info.cp) + ' en nuestras zonas de entrega.' : 'Todavía no entregamos en ' + esc(info.colonia || info.cp) + '.';
      return '<div class="ns2-note ns2-note--warn"><p class="ns2-note__text"><strong>' + txt + '</strong> ' +
        (wa ? '<a href="' + esc(E.whatsappUrl(wa, E.requestText(info.cp))) + '" target="_blank" rel="noopener">Pregúntanos por WhatsApp</a>' : '<a href="' + esc(CFG.entregasUrl || '/pages/como-funciona') + '">Ver zonas de entrega</a>') + '.</p></div>';
    }
    if (info.offset == null) {
      return '<div class="ns2-note ns2-note--ok"><p class="ns2-note__text"><strong>Sí entregamos en ' + esc(info.colonia || 'el CP ' + info.cp) + '.</strong> ' +
        'Al confirmar tu pedido te decimos tu día y horario.</p></div>';
    }
    var lista = E.upcoming(info, weeks).map(function (x) {
      return '<li><span class="ns2x-ent__dia">' + S.icon('truck') + esc(cap(x.text)) + '</span><span class="ns2-small">Platillos de ' + esc(Rl.weekShort(x.week.monday)) + '</span></li>';
    }).join('');
    return '<p class="ns2x-ent__ruta">' + S.icon('clock') + '<span>Tu día es el <strong>' + esc(E.dayName(info)) + '</strong>' + (info.horario ? ', de <strong>' + esc(info.horario) + '</strong>' : '') + '.</span></p>' +
      '<ul class="ns2x-ent__lista">' + lista + '</ul>' +
      (CFG.corte ? '<p class="ns2-small">' + esc(CFG.corte) + (wa ? ' <a href="' + esc(wa) + '" target="_blank" rel="noopener">WhatsApp</a>' : '') + '</p>' : '');
  }

  function bloqueEntregas(body, s, ctx) {
    var weeks = semanasDelPedido(s, ctx);
    if (!weeks.length || !E) return;
    var cp = E.savedCp();
    var sec = doc.createElement('section');
    sec.className = 'ns2-group ns2x-ent';
    sec.innerHTML = '<div class="ns2-group__head"><p class="ns2-group__title">' + S.icon('calendar') + '¿Cuándo te llega?</p></div>' +
      '<label class="ns2x-ent__cp"><span>Tu código postal</span><input type="text" inputmode="numeric" autocomplete="postal-code" maxlength="5" pattern="[0-9]*" placeholder="64000" value="' + esc(cp) + '"></label>' +
      '<div class="ns2x-ent__out" aria-live="polite"></div>';
    body.insertBefore(sec, body.firstChild);
    var out = sec.querySelector('.ns2x-ent__out'), input = sec.querySelector('input');
    function pintar(v) {
      cargarCobertura().then(function (data) { if (sec.isConnected) out.innerHTML = htmlEntregas(data ? E.lookup(data, v) : null, weeks, v); });
    }
    input.addEventListener('input', function () {
      var v = input.value.replace(/\D/g, '').slice(0, 5);
      if (input.value !== v) input.value = v;
      if (v.length === 5) E.saveCp(v);
      pintar(v);
    });
    pintar(cp);
  }

  // Macros de un platillo personalizado: propiedad "Macros" de su línea "platillo".
  function macrosCustom(it) {
    var m = String((it.properties || {}).Macros || '');
    var k = /([\d.,]+)\s*kcal/i.exec(m), p = /prote[ií]na\s*([\d.,]+)/i.exec(m);
    return k ? { kcal: num(k[1].replace(',', '')), proteina: p ? num(p[1].replace(',', '')) : 0 } : null;
  }

  function bloqueTotales(body, cart, ctx) {
    var items = (cart.items || []).filter(function (it) {
      var pr = it.properties || {};
      return !(pr._ns_cm && pr._ns_cm_rol && pr._ns_cm_rol !== 'platillo'); // ingredientes de un personalizado no cuentan aparte
    });
    if (!items.length || !N) return;
    var sec = doc.createElement('section');
    sec.className = 'ns2-group ns2x-tot';
    sec.hidden = true;
    body.appendChild(sec);
    Promise.all(items.map(function (it) {
      if ((it.properties || {})._ns_cm) return Promise.resolve(macrosCustom(it));
      return datoDe(it.handle);
    })).then(function (ds) {
      if (!sec.isConnected) return;
      var grupos = {}, orden = [], tot = { q: 0, qd: 0, k: 0, p: 0 };
      items.forEach(function (it, i) {
        var kind = R.cartKind(it);
        var id = kind === 'Express' ? 'express' : Rl.lineWeekId(it, ctx.weeks);
        if (!grupos[id]) { grupos[id] = { q: 0, qd: 0, k: 0, p: 0 }; orden.push(id); }
        var g = grupos[id], q = it.quantity || 0, d = ds[i];
        g.q += q; tot.q += q;
        if (d && num(d.kcal) > 0) {
          g.qd += q; g.k += num(d.kcal) * q; g.p += num(d.proteina) * q;
          tot.qd += q; tot.k += num(d.kcal) * q; tot.p += num(d.proteina) * q;
        }
      });
      if (!tot.qd) return;
      orden.sort();
      var fila = function (label, g) {
        return '<div class="ns2x-tot__fila"><span class="ns2x-tot__sem">' + esc(label) + '<small>' + Rl.dishes(g.q) + '</small></span>' +
          '<span><b>' + fmt(g.k) + '</b> kcal</span><span><b>' + fmt(g.p) + ' g</b> proteína</span></div>';
      };
      var h = '<div class="ns2-group__head"><p class="ns2-group__title">' + S.icon('spark') + 'Tu selección en números</p></div>';
      orden.forEach(function (id) {
        var w = Rl.findWeek(ctx.weeks, id) || (ctx.current && ctx.current.id === id ? ctx.current : null);
        var label = id === 'express' ? 'Express' : (w ? Rl.weekLabel(w.monday) : 'Otra semana');
        h += fila(label, grupos[id]);
      });
      if (orden.length > 1) h += fila('Total', tot).replace('ns2x-tot__fila', 'ns2x-tot__fila is-total');
      h += '<p class="ns2x-tot__prom">Promedio por platillo: <b>' + fmt(tot.k / tot.qd) + ' kcal</b> · <b>' + fmt(tot.p / tot.qd) + ' g</b> de proteína</p>';
      var sinDatos = tot.q - tot.qd;
      h += '<p class="ns2-small">' + (sinDatos ? 'Sin datos en ' + Rl.dishes(sinDatos) + '. ' : '') + 'Valores aproximados calculados de las recetas.</p>';
      sec.innerHTML = h;
      sec.hidden = false;
    });
  }

  doc.addEventListener('ns:order-render', function (e) {
    var d = e.detail || {};
    if (!d.body || !d.summary || !d.summary.qty) return;
    bloqueEntregas(d.body, d.summary, d.ctx || S.ctx());
    bloqueTotales(d.body, d.cart || { items: [] }, d.ctx || S.ctx());
  });

  /* =========== 4. Resumen fijo en celular =========== */
  function semanasFijas() {
    var mq = global.matchMedia ? global.matchMedia('(max-width: 1023px)') : { matches: true };
    doc.querySelectorAll('.ns2 .ns2-weeks').forEach(function (w) {
      w.classList.add('ns2x-fijo');
      var marca = doc.createElement('div');
      marca.className = 'ns2x-marca';
      marca.setAttribute('aria-hidden', 'true');
      w.parentNode.insertBefore(marca, w);
      if (global.IntersectionObserver) {
        new IntersectionObserver(function (en) {
          w.classList.toggle('is-stuck', mq.matches && !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(marca);
      }
    });
    // Si el encabezado del tema se queda fijo arriba, las semanas se acomodan debajo.
    var raf = 0;
    function alto() {
      raf = 0;
      // Horizon: <header-component sticky="always|scroll-up">; lo fijo puede ser él o su contenedor.
      var hd = doc.querySelector('header-component') || doc.querySelector('header');
      var top = 0;
      for (var el = hd; el && el !== doc.body; el = el.parentElement) {
        var pos = global.getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') {
          var r = hd.getBoundingClientRect();
          if (r.bottom > 0 && r.top < 2) top = Math.round(r.bottom);
          break;
        }
      }
      doc.documentElement.style.setProperty('--ns2x-top', top + 'px');
    }
    global.addEventListener('scroll', function () { if (!raf) raf = global.requestAnimationFrame(alto); }, { passive: true });
    global.addEventListener('resize', alto);
    alto();
  }

  // Planes: en celular el resumen del plan (que en escritorio va a la derecha) se abre desde la barra.
  function resumenPlan() {
    var root = doc.getElementById('ns2Planes');
    if (!root || !S.order || !S.order.bar) return;
    var info = S.order.bar.querySelector('.ns2-bar__info');
    var btn = doc.createElement('button');
    btn.type = 'button';
    btn.className = 'ns2-link ns2x-resbtn';
    btn.innerHTML = S.icon('info') + 'Ver resumen de tu plan';
    btn.hidden = true;
    info.appendChild(btn);
    function aside() {
      var scr = root.querySelector('[data-screen="config"]');
      var a = scr && !scr.hidden && root.querySelector('.ns2-config__aside');
      return a && a.textContent.trim() ? a : null;
    }
    function sync() { btn.hidden = !aside(); }
    new MutationObserver(sync).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    sync();
    btn.addEventListener('click', function () {
      var a = aside();
      if (!a) return;
      var prev = doc.activeElement;
      var wrap = doc.createElement('div');
      wrap.className = 'ns2-layer ns2-modal-wrap ns2x-res';
      var copia = a.cloneNode(true);
      copia.querySelectorAll('button, a, .ns2-sum__cta').forEach(function (n) { if (n.closest('.ns2-sum__cta') || n.tagName !== 'A') n.remove(); });
      wrap.innerHTML = '<div class="ns2-modal ns2x-res__box" role="dialog" aria-modal="true" aria-label="Resumen de tu plan">' +
        '<button type="button" class="ns2-close ns2x-res__close" aria-label="Cerrar">×</button><div class="ns2x-res__body"></div></div>';
      wrap.querySelector('.ns2x-res__body').appendChild(copia);
      copia.classList.add('ns2x-res__aside');
      doc.body.appendChild(wrap);
      function cerrar() { wrap.remove(); doc.removeEventListener('keydown', tecla, true); if (prev && prev.focus) prev.focus(); }
      function tecla(e) { if (e.key === 'Escape') { e.stopPropagation(); cerrar(); } }
      doc.addEventListener('keydown', tecla, true);
      wrap.addEventListener('click', function (e) { if (e.target === wrap || e.target.closest('.ns2x-res__close')) cerrar(); });
      wrap.querySelector('.ns2x-res__close').focus();
    });
  }

  /* =========== 5. Guardar la selección y repetir el último pedido =========== */
  function minimo(it) {
    return { id: it.variant_id || it.id, quantity: it.quantity, handle: it.handle, title: it.product_title || it.title, properties: it.properties || {} };
  }
  function hoyIso() { return Rl.isoDate ? Rl.isoDate(new Date()) : new Date().toISOString().slice(0, 10); }
  function fechaCorta(iso) {
    var p = String(iso || '').split('-');
    if (p.length !== 3) return '';
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return d.getDate() + ' ' + ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'][d.getMonth()];
  }
  function piezas(items) { return items.reduce(function (s, i) { return s + (parseInt(i.quantity, 10) || 0); }, 0); }

  doc.addEventListener('ns:checkout', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !(cart.items || []).length) return;
    var items = cart.items.map(minimo);
    escribir(K_ULT, { fuente: 'navegador', fecha: hoyIso(), items: items });
    var sel = leer(K_SEL, null);
    if (sel) { sel.pagado = true; escribir(K_SEL, sel); }
  });

  // Líneas de una selección guardada que siguen a la venta (mismas semanas).
  function vigentes(items, ctx) {
    var alc = ctx.alcWeeks || ctx.weeks;
    var planes = {}, ok = [], fuera = 0;
    items.forEach(function (it) {
      var kind = R.cartKind(it), wid = Rl.lineWeekId(it, ctx.weeks);
      if (kind === 'Express') { fuera += it.quantity; return; }
      if (kind === 'Planes') { var k = Rl.linePlanKey(it); (planes[k] = planes[k] || []).push(it); return; }
      if (Rl.findWeek(alc, wid)) ok.push(it); else fuera += it.quantity;
    });
    Object.keys(planes).forEach(function (k) {
      var ls = planes[k];
      var todas = ls.every(function (it) { return Rl.findWeek(ctx.weeks, Rl.lineWeekId(it, ctx.weeks)); });
      if (todas) ok = ok.concat(ls); else fuera += piezas(ls);
    });
    return { items: ok, fuera: fuera };
  }

  async function agregar(items) {
    for (var i = 0; i < items.length; i += 20) {
      await S.api.addMany(items.slice(i, i + 20).map(function (it) { return { id: it.id, quantity: it.quantity, properties: it.properties }; }));
    }
    var cart = await S.order.refresh();
    if (S.syncDiscountAttr) await S.syncDiscountAttr(cart);
    return cart;
  }

  function aviso(html, onClick) {
    var h = host();
    var wrap = h && h.querySelector('.ns2-wrap');
    if (!wrap) return null;
    quitarAvisos();
    var box = doc.createElement('div');
    box.className = 'ns2x-aviso';
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', 'Tu pedido anterior');
    box.innerHTML = html;
    wrap.insertBefore(box, wrap.firstChild);
    box.addEventListener('click', function (e) { var b = e.target.closest('button[data-x]'); if (b) onClick(b.getAttribute('data-x'), b, box); });
    return box;
  }
  function quitarAvisos() { doc.querySelectorAll('.ns2x-aviso').forEach(function (n) { n.remove(); }); }

  function ofrecerRecuperar(sel, ctx) {
    var v = vigentes(sel.items || [], ctx);
    if (!v.items.length) { escribir(K_SEL, null); return false; }
    var n = piezas(v.items);
    aviso('<div class="ns2x-aviso__ico">' + S.icon('check') + '</div><div class="ns2x-aviso__txt"><strong>Guardamos tu selección: ' + Rl.dishes(n) + '.</strong>' +
      '<span>La armaste el ' + esc(fechaCorta(sel.fecha)) + ' y no terminaste tu pedido.' + (v.fuera ? ' ' + Rl.dishes(v.fuera) + ' ya no se pueden pedir.' : '') + '</span></div>' +
      '<div class="ns2x-aviso__acc"><button type="button" class="ns2-btn ns2-btn--primary" data-x="si">Recuperar mi selección</button>' +
      '<button type="button" class="ns2-btn ns2-btn--quiet" data-x="no">Empezar de nuevo</button></div>', async function (x, b, box) {
      if (x === 'no') { escribir(K_SEL, null); box.remove(); return; }
      b.classList.add('is-busy'); b.disabled = true;
      try { await agregar(v.items); box.remove(); S.toast('Recuperamos tu selección.', true); S.order.open(); }
      catch (e) { b.disabled = false; b.classList.remove('is-busy'); S.toast(S.friendlyError(e, 'add')); S.order.refresh(); }
    });
    return true;
  }

  // ---- Repetir: los mismos platillos en las próximas semanas con el mismo menú ----
  function lunesDeId(id) {
    var m = /^(\d{4})-W(\d{2})$/.exec(String(id || ''));
    if (!m) return null;
    var y = +m[1], w = +m[2];
    var jan4 = new Date(y, 0, 4), dow = (jan4.getDay() + 6) % 7;
    return new Date(y, 0, 4 - dow + 7 * (w - 1));
  }
  function menuDe(it) { var n = parseInt(String((it.properties || {}).Menu || '').replace(/\D+/g, ''), 10); return n || null; }
  function semanasEntre(a, b) { return Math.round((b - a) / (7 * 864e5)); }

  // Arma las líneas nuevas. Devuelve { items, grupos: [texto], fuera, agotados }.
  async function planRepetir(ult, ctx, cartNow) {
    var items = (ult.items || []).filter(function (it) { return it.id && it.quantity > 0; });
    var planes = {}, alc = {}, fuera = 0, nuevos = [], grupos = [], agotados = 0;
    items.forEach(function (it) {
      var kind = R.cartKind(it);
      if (kind === 'Planes' && (it.properties || {}).BundleCode) { var k = Rl.linePlanKey(it); (planes[k] = planes[k] || []).push(it); }
      else if (kind === 'A la carta' && menuDe(it)) { var w = Rl.lineWeekId(it, []); (alc[w] = alc[w] || []).push(it); }
      else fuera += it.quantity;
    });
    var menusNeeded = {};
    items.forEach(function (it) { var m = menuDe(it); if (m) menusNeeded[m] = true; });
    var disp = {};
    await Promise.all(Object.keys(menusNeeded).map(function (m) {
      return S.api.menu('menu' + m).then(function (ps) {
        ps.forEach(function (p) { (p.variants || []).forEach(function (v) { disp[String(v.id)] = !!v.available; }); });
      }).catch(function () { /* sin menú: no se agrega */ });
    }));
    function tomar(it, props) {
      if (!disp[String(it.id)]) { agotados += it.quantity; return; }
      nuevos.push({ id: it.id, quantity: it.quantity, properties: props, handle: it.handle });
    }
    var usados = {};
    Object.keys(planes).forEach(function (key) {
      var ls = planes[key], code = Rl.splitPlanKey(key).code;
      var ids = ls.map(function (it) { return Rl.lineWeekId(it, []); }).filter(function (v, i, a) { return a.indexOf(v) === i; }).sort();
      var base = lunesDeId(ids[0]);
      var m0 = menuDe(ls.filter(function (it) { return Rl.lineWeekId(it, []) === ids[0]; })[0]);
      if (!base || !m0) { fuera += piezas(ls); return; }
      var inicio = ctx.weeks.filter(function (w) {
        if (w.menu !== m0) return false;
        return ids.every(function (id) { var mon = lunesDeId(id); return mon && Rl.findWeek(ctx.weeks, Rl.weekInfo(Rl.addWeeks(w.monday, semanasEntre(base, mon))).id); });
      })[0];
      if (!inicio) { fuera += piezas(ls); return; }
      usados[code] = (usados[code] || Rl.nextPlanNumber(cartNow, code) - 1) + 1;
      var n = usados[code];
      ls.forEach(function (it) {
        var w = Rl.weekInfo(Rl.addWeeks(inicio.monday, semanasEntre(base, lunesDeId(Rl.lineWeekId(it, [])))));
        var pr = { 'Tipo de compra': 'Planes', BundleCode: code, 'Plan #': String(n), Semana: w.iso, 'Semana ID': w.id, Menu: 'Menu' + w.menu, Entrega: Rl.deliveryWindow(w.monday) };
        if (it.properties._ns_pct != null) pr._ns_pct = String(it.properties._ns_pct);
        tomar(it, pr);
      });
      var cfg = Rl.parseBundleCode(code);
      grupos.push('Plan ' + (cfg ? cfg.plan : code) + ' · ' + Rl.dishes(piezas(ls)) + ' desde ' + Rl.weekShort(inicio.monday));
    });
    Object.keys(alc).forEach(function (wid) {
      var ls = alc[wid], m = menuDe(ls[0]);
      var w = (ctx.alcWeeks || ctx.weeks).filter(function (x) { return x.menu === m; })[0];
      if (!w) { fuera += piezas(ls); return; }
      ls.forEach(function (it) {
        tomar(it, { 'Tipo de compra': 'A la carta', Semana: w.iso, 'Semana ID': w.id, Menu: 'Menu' + w.menu, Entrega: Rl.deliveryWindow(w.monday) });
      });
      grupos.push('A la carta · ' + Rl.dishes(piezas(ls)) + ' para ' + Rl.weekShort(w.monday));
    });
    return { items: nuevos, grupos: grupos, fuera: fuera, agotados: agotados };
  }

  function repetibles(ult) {
    return (ult.items || []).filter(function (it) { var k = R.cartKind(it); return it.id && (k === 'Planes' || k === 'A la carta') && menuDe(it); });
  }

  function ofrecerRepetir(ult, ctx) {
    var rep = repetibles(ult);
    if (!rep.length) return false;
    var tipos = {};
    rep.forEach(function (it) { var k = R.cartKind(it); if (k === 'Planes') { var c = Rl.parseBundleCode(it.properties.BundleCode); tipos['Plan ' + (c ? c.plan : '')] = true; } else tipos['A la carta'] = true; });
    aviso('<div class="ns2x-aviso__ico">' + S.icon('spark') + '</div><div class="ns2x-aviso__txt"><strong>¿Lo mismo que la última vez?</strong>' +
      '<span>Tu pedido' + (ult.fecha ? ' del ' + esc(fechaCorta(ult.fecha)) : '') + ': ' + esc(Object.keys(tipos).join(' y ')) + ' · ' + Rl.dishes(piezas(rep)) + '.</span></div>' +
      '<div class="ns2x-aviso__acc"><button type="button" class="ns2-btn ns2-btn--primary" data-x="si">Repetir mi pedido</button>' +
      '<button type="button" class="ns2-btn ns2-btn--quiet" data-x="no">Ahora no</button></div>', async function (x, b, box) {
      if (x === 'no') { sesion(K_NO, '1'); box.remove(); return; }
      b.classList.add('is-busy'); b.disabled = true;
      var plan;
      try { plan = await planRepetir(ult, S.ctx(), S.order.cart()); }
      catch (e) { plan = null; }
      b.classList.remove('is-busy'); b.disabled = false;
      if (!plan || !plan.items.length) {
        S.dialog({ title: 'No pudimos repetir tu pedido', text: 'Los platillos de tu último pedido no están a la venta en las próximas semanas. Elige del menú, por favor.', actions: [{ label: 'Entendido', style: 'primary' }] });
        return;
      }
      var extra = [];
      if (plan.agotados) extra.push(Rl.dishes(plan.agotados) + ' están agotados o ya no están en el menú');
      if (plan.fuera) extra.push(Rl.dishes(plan.fuera) + ' (Express, personalizados o semanas fuera de rango) se eligen de nuevo');
      S.dialog({
        title: 'Repetir tu último pedido',
        text: 'Vamos a agregar ' + Rl.dishes(piezas(plan.items)) + ': ' + plan.grupos.join('; ') + '.' + (extra.length ? ' ' + cap(extra.join('. ')) + '.' : '') + ' Revisa tu pedido antes de pagar.',
        actions: [
          { label: 'Agregar a mi pedido', style: 'primary', fn: async function () {
            try { await agregar(plan.items); box.remove(); S.toast('Listo, agregamos tu pedido anterior.', true); S.order.open(); }
            catch (e) { S.toast(S.friendlyError(e, 'add')); S.order.refresh(); }
          } },
          { label: 'Cancelar', style: 'quiet' }
        ]
      });
    });
    return true;
  }

  var primera = true, vistoConItems = false;
  doc.addEventListener('ns:cart', function (e) {
    var cart = (e.detail && e.detail.cart) || { items: [] };
    var items = cart.items || [];
    if (items.length) {
      vistoConItems = true;
      var prev = leer(K_SEL, null);
      escribir(K_SEL, { fecha: (prev && !prev.pagado && prev.fecha) || hoyIso(), t: Date.now(), items: items.map(minimo) });
      quitarAvisos();
    } else if (vistoConItems) {
      escribir(K_SEL, null); // el cliente vació su pedido
    }
    if (!primera) return;
    primera = false;
    if (items.length || !S.order) return;
    var ctx = S.ctx();
    var sel = leer(K_SEL, null);
    if (sel && !sel.pagado && Date.now() - (sel.t || 0) < DIAS_SELECCION * 864e5 && ofrecerRecuperar(sel, ctx)) return;
    if (sel && (sel.pagado || Date.now() - (sel.t || 0) >= DIAS_SELECCION * 864e5)) escribir(K_SEL, null);
    if (sesion(K_NO)) return;
    var ult = CFG.ultimoPedido || leer(K_ULT, null);
    if (ult) ofrecerRepetir(ult, ctx);
  });

  /* =========== Arranque =========== */
  function iniciar() {
    if (!host()) return;
    vigilarGrids();
    semanasFijas();
    // El módulo monta su barra en DOMContentLoaded; el resumen del plan espera a que exista.
    setTimeout(resumenPlan, 0);
  }
  // Este archivo es diferido: corre antes de DOMContentLoaded, cuando los módulos aún no montan su barra.
  if (doc.readyState === 'complete') iniciar();
  else doc.addEventListener('DOMContentLoaded', iniciar);
})(typeof window !== 'undefined' ? window : globalThis);
